<template>
  <div class="home">
    <section class="row p-0 m-0">
      <!--      main-->
      <section class="justify-content-between col-12 col-lg-9 mx-auto m-0 p-0">
      <!--      main-->

        <!-- Header -->
        <the-header/>
        <!-- End Header-->

        <!--count-->
        <counters/>
        <!--End count-->

        <!-- Categories -->
        <categories/>
        <!--End Categories-->

        <!-- About-->
        <the-about/>
        <!-- End About-->

        <!--invite-->
       <invite />
        <!--End invite-->

      </section>
      <!--     End main-->

      <!--      side-->
      <section id="side" class="col-12 col-lg-3 mx-auto px-4 ps-md-1 pe-md-0">
        <div id="inner">
          <section class="card mb-2 ms-md-2 rounded rounded-0 ">
            <section class="card-header rounded rounded-0">ورود به سایت</section>
            <section class="card-body p-1 rounded rounded-0 ">
              <section class="card-img text-center">
              </section>

              <div class="col-12  mx-auto">

                <form class="form1 pt-3 row mx-auto justify-content-center" action="">

                  <div class="form-group col-12 mb-2">
                    <input type="password" class="form-control form-control-sm" id="email" placeholder="ایمیل"
                           name="email">
                  </div>
                  <div class="form-group col-12 mb-2">
                    <input type="password" class="form-control form-control-sm" id="pwd" placeholder="رمز عبور"
                           name="pswd">
                  </div>
                  <!--                 <div class = "form-group col-12 mb-2">-->
                  <!--                   <div class = "custom-control custom-checkbox">-->
                  <!--                     <input type = "checkbox" class = "custom-control-input" id = "customCheck" name = "example1" checked-->
                  <!--                            style = "cursor: pointer">-->
                  <!--                     <label class = "custom-control-label" for = "customCheck" style = "font-size: 14px; cursor:-->
                  <!--                        pointer">مرا به خاطر بسپار</label>-->
                  <!--                   </div>-->
                  <!--                 </div>-->

                  <div class="form-group col-12">
                    <button type="submit" class="btn btn-sm btn-block mb-2 btn-success me-2">ورود</button>
                    <a class=" w-100" style="font-size: 12px;" href="">فراموشی رمز</a>

                  </div>


                </form>
              </div>

            </section>
          </section>
          <section class="card mb-2 ms-md-2 rounded rounded-0 ">
            <section class="card-header rounded rounded-0">ثبت نام سریع</section>
            <section class="card-body p-1 rounded rounded-0 ">
              <section class="card-img text-center">
              </section>

              <div class="col-12  mx-auto">

                <form class="form1 pt-3 row mx-auto justify-content-center" action="">

                  <div class="form-group col-12 mb-2">
                    <input type="text" class="form-control form-control-sm" id="email" placeholder="نام" name="email">
                  </div>
                  <div class="form-group col-12 mb-2">
                    <input type="text" class="form-control form-control-sm" id="email" placeholder="ایمیل" name="email">
                  </div>
                  <div class="form-group col-6 mb-2 px-1">
                    <input type="password" class="form-control form-control-sm" id="pwd" placeholder="رمز عبور"
                           name="pswd">
                  </div>
                  <div class="form-group col-6 mb-2 px-1">
                    <input type="password" class="form-control form-control-sm" id="pwd" placeholder="تکرار رمز عبور"
                           name="pswd">
                  </div>
                  <div class="form-group col-12 mb-2 ">
                    <div class="custom-control custom-checkbox">
                      <!--                    <input type = "checkbox" class = "custom-control-input" id = "customCheck" name = "example1" checked-->
                      <!--                           style = "cursor: pointer">-->
                      <!--                    <label class = "custom-control-label" for = "customCheck" style = "font-size: 14px; cursor:-->
                      <!--                        pointer">مرا به خاطر بسپار</label>-->
                    </div>
                  </div>

                  <div class="form-group col-12">
                    <button type="submit" class="btn btn-sm btn-block mb-2 btn-success me-2">ورود</button>
                  </div>


                </form>
              </div>

            </section>
          </section>
          <section class="card mb-2 ms-md-2 rounded rounded-0 d-none">
            <section class="card-header rounded rounded-0">مشخصات شما</section>
            <section class="card-body p-1 rounded rounded-0 ">
              <section class="card-img text-center">
              </section>

              <div class="container text-center col-12  mx-auto">


                <p class="text-center m-0 mt-4" style="font-size: 50px"><i class="fas fa-user-circle"></i></p>
                <p class="text-center h5">رکسانا رحیمی</p>
                <p class="text-center">roxanarahimi@gmail.com</p>
                <a class="btn btn-sm btn-primary mx-auto mb-3">پروفایل</a>

              </div>

            </section>
          </section>
        </div>
      </section>
      <!--    End  side-->
    </section>
  </div>
</template>

<script>
// @ is an alias to /src

import TheHeader from "@/components/TheHeader";
import Counters from "@/components/Counters";
import Categories from "@/components/Categories";
import TheAbout from "@/components/TheAbout";
import Invite from "@/components/Invite";

export default {
  name: 'Home',
  components: {Invite, TheAbout, Categories, Counters, TheHeader},
  data() {
    return {}
  },
  mounted() {
    // document.addEventListener('scroll', () => {
    //     // let top = document.documentElement.scrollTop;
    //     // let main = document.querySelector('main').offsetHeight - top;
    //     // let side = document.querySelector('#inner').offsetHeight;
    //
    //     // console.log('--------------------');
    //     // console.log(main > side);
    //     // console.log(main === side);
    //     // console.log(main < side);
    //     // console.log('--------------------');
    //     // console.log(side);
    //     // console.log(main);
    //
    //     let footer = document.querySelector('footer').offsetHeight;
    //     // console.log(footer);
    //     if (document.querySelector('#side > #inner') && (top > 56)) {
    //         document.querySelector('#side > #inner').setAttribute('style', 'top:56px;');
    //     }
    //     if (main < side) {
    //         document.querySelector('#side > #inner').removeAttribute('style');
    //         // document.querySelector('#side > #inner').style.remove('top');
    //         // document.querySelector('#side > #inner').style.bottom = footer;
    //         // console.log('footer',footer)
    //         // document.querySelector('#side > #inner').style.marginBottom = footer + 'px';
    //         // console.log(document.querySelector('#side > #inner').style.)
    //
    //         // document.querySelector('#side > #inner').style.position = 'static';
    //         document.querySelector('#side > #inner').style.bottom = footer + 'px';
    //
    //     }
    // });
  }
}
</script>
<style>
#side #inner {
  /*border: 1px solid lightgray;*/
  /*border-right: none;*/
  /*border-radius: 3px;*/
  /*position: -webkit-sticky !important; !* Safari *!*/
  /*position: sticky !important;*/
  /*top: 0 !important;*/

  transition: 1s ease;
  position: static;
  /*width: 25% !important;*/

}

@media (min-width: 920px) {
  #side #inner {
    /*border: 1px solid lightgray;*/
    /*border-right: none;*/
    /*border-radius: 3px;*/
    /*position: -webkit-sticky !important; !* Safari *!*/
    /*position: sticky !important;*/
    /*top: 0 !important;*/

    transition: 1s ease;
    position: fixed;
    width: 295px !important;
  }
}


</style>